import React, { Component } from "react";

import packetPage1 from "../assets/immunization/packet_page_1.JPG";
import packetPage1Bottom from "../assets/immunization/packet_page_1_bottom.JPG";
import packetPage2 from "../assets/immunization/packet_page_2.JPG";
import packetPage3 from "../assets/immunization/packet_page_3.JPG";
import packetPage4 from "../assets/immunization/packet_page_4.JPG";

export default class immunization extends Component {
  render() {
    return (
      <React.Fragment>
        <div>
          The university needs to see your immunization records which includes the list of vaccines that are required before enrolling. You
          might also need to do TB testing depending. You can find more details and list of required vaccinations here:{" "}
          <a href="https://healthcenter.uga.edu/info/immunizations/" target={"_blank"} rel={"noreferrer"} className="redLink">
            Immunization requirements
          </a>
        </div>
        <hr />
        <section>
          <header className="section_head">Which vaccines are you required to take?</header>
          <br />
          <p>There are various vaccines you might have taken at the age 1-5. You can find these in your health card.</p>
          <div>
            The list of vaccines which are mandatory:
            <br />
            <br />
            <ol>
              <li>MMR (Measles, Mumps, Rubella)</li>
              <li>Varicella (Chicken Pox)</li>
              <li>Tetanus/Diptheria (Tdap) - If you have taken this vaccine more than 10 years ago, you will have to take it again</li>
              <li>Hepatitis B</li>
              <li>TB (Tuberculosis screening) </li>
            </ol>
          </div>
        </section>
        <section>
          <header className="section_head">How to submit the immunization documents?</header>
          <br />
          <p>
            If you go to this link -{" "}
            <a href="https://healthcenter.uga.edu/info/immunizations/" target={"_blank"} rel={"noreferrer"} className="redLink">
              Immunization requirements
            </a>{" "}
            &nbsp; you can find the required as well as recommended vaccines. Before that you can find Immunizations Packet link which is a
            pdf that you need to submit as proof.
            <br />
            You can find PDF here:{" "}
            <a
              href="https://healthcenter.uga.edu/wp-content/uploads/sites/19/2021/04/immunizations-packet.pdf"
              className="redLink"
              target={"_blank"}
              rel={"noreferrer"}
            >
              Immunization Packet PDF
            </a>
            <br />
            If the above pdf link is invalid you can find the link to pdf as mentioned above
          </p>
        </section>
        <section>
          <header className="section_head">How to fill the immunization packet?</header>
          <br />
          <p>
            Now that you have downloaded the PDF let's go through it. This PDF has to be filled by your doctor. You can print the document
            to fill the details.
          </p>
          <hr />
          <h4>Page 1</h4>
          <div className="text-center">
            <img src={packetPage1} className="rounded img-thumbnail packet_page_img" alt="pdf page1" />
          </div>
          <br />
          <ul>
            <li>If you have already taken these vaccines your doctor needs to add the dates corresponding to when you took the vaccine.</li>
            <li>If you have taken TDAP more than 10 years ago, you need to take it again.</li>
            <li>
              You may have/need to take/taken the Hepatitis B vaccine, it is mandatory only for students who are <b>{"<"} 18 years old.</b>
            </li>
            <li>
              The Meningococcol vaccine is not mandatory. It is strongly recommended for those who are {"<"} 22 years old. You can send a
              mail to <a href="mailto:RHI@uhs.uga.edu">RHI@uhs.uga.edu</a> if you have any query regarding any vaccinations.
            </li>
          </ul>
          <div className="text-center">
            <img src={packetPage1Bottom} className="rounded img-thumbnail packet_page_img" alt="pdf page1_bottom" />
          </div>
          <br />
          <ul>
            <li>The above image shows the recommended vaccines, these are not mandatory if you don't wish to take.</li>
            <li>You doctor needs to fill their details in the given fields such as name, address, phone number and signature</li>
          </ul>
          <hr />
          <h4>Page 2</h4>
          <div className="text-center">
            <img src={packetPage2} className="rounded img-thumbnail packet_page_img" alt="pdf page2" />
          </div>
          <br />
          <ul>
            <li>The second page contains a questionare to check whether are required to take the TB Test.</li>
            <li>For example, if you are from INDIA then you need to take the test as it is mentioned in the list of countries</li>
            <li>Make sure to provide your signature here</li>
          </ul>
          <hr />
          <h4>Page 3</h4>
          <div className="text-center">
            <img src={packetPage3} className="rounded img-thumbnail packet_page_img" alt="pdf page3" />
          </div>
          <br />
          <ul>
            <li>The third page asks you whether you had a positive TB skin test and whether you have taken the BCG vaccine.</li>
            <li>Now there are two test you can take if any of the answers to the quesitons in page 2 was yes</li>
            <li>One is TST and other is IGRA</li>
            <li>
              If you are from India, you most likely have taken the BCG vaccine. If this is the case I recommend you to take IGRA instead of
              TST
            </li>
            <li>Your doctor is the one who is filling this form, so you can ask them about the proceedure</li>
            <li>
              If you took the TST, then you need to fill the result details in this page. If you took IGRA, then you can skip the TST fields
            </li>
            <li>The results of IGRA should be filled in page 4</li>
          </ul>
          <hr />
          <h4>Page 4</h4>
          <div className="text-center">
            <img src={packetPage4} className="rounded img-thumbnail packet_page_img" alt="pdf page4" />
          </div>
          <br />
          <ul>
            <li>This is the final page where in you fill the IGRA test results.</li>
            <li>If the results are positive, you need to take a chest X ray. If they are negative, you do not need to take the X-ray</li>
            <li>Your doctor will help you with the Part 3 of this form. In most cases you will not need this section</li>
            <li>
              Finally, you doctor needs to fill in their details again. <b>Make sure your doctor also stamps their seal over this part</b>
            </li>
          </ul>
          <hr />
          <ul>
            <li>Fill out the details on top of each page of the pdf.</li>
            <li>If you have taken any vaccine again, attach the proof at the end</li>
            <li>If you have taken the TST or IGRA attach the results at the end</li>
            <li>
              Once all these steps are complete you can send the documents via email here -{" "}
              <a href="mailto:RHI@uhs.uga.edu">RHI@uhs.uga.edu</a>. &nbsp;{" "}
              <b className="text-danger">Don't forget to provide your UGA ID in the email.</b>
            </li>
          </ul>
          <br />
          If the documents are up to the mark you will recieve confirmation email. In 1-4 working days your hold will also be cleared -
          which you can check on the status portal
          <br />
          <br />
        </section>
      </React.Fragment>
    );
  }
}
